import React, { useState, useEffect } from 'react'
import api from '../../services/api'
import { showSuccess, showError, showWarning, showInfo, showConfirm } from '../../utils/alert';
import { useTrusteesFooter } from '../../components/reportTrusteesFooter';


function SHU() {
  const [tahun, setTahun] = useState(new Date().getFullYear())
  const [shuData, setShuData] = useState(null)
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [showSettings, setShowSettings] = useState(false)
  const [settingsForm, setSettingsForm] = useState({
    DanaCadangan: 0,
    JasaModal: 20,
    JasaAnggota: 25,
    DanaPengurus: 10,
    DanaSosial: 5
  })
  const { trustees } = useTrusteesFooter(`${tahun}-01-01`, `${tahun}-12-31`)

  useEffect(() => {
    fetchSettings()
  }, [tahun])

  const fetchSettings = async () => {
    try {
      const response = await api.get(`/shu/settings/${tahun}`)
      setSettings(response.data.data)
      setSettingsForm({
        DanaCadangan: response.data.data.DanaCadangan,
        JasaModal: response.data.data.JasaModal,
        JasaAnggota: response.data.data.JasaAnggota,
        DanaPengurus: response.data.data.DanaPengurus,
        DanaSosial: response.data.data.DanaSosial
      })
    } catch (error) {
      console.error('Error fetching settings:', error)
    }
  }

  const calculateSHU = async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await api.get(`/shu/calculate/${tahun}`)
      setShuData(response.data.data)
    } catch (error) {
      setError(error.response?.data?.message || 'Gagal menghitung SHU')
    } finally {
      setLoading(false)
    }
  }

  const saveSettings = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      await api.put(`/shu/settings/${tahun}`, settingsForm)
      showSuccess('Pengaturan SHU berhasil disimpan')
      setShowSettings(false)
      fetchSettings()
    } catch (error) {
      setError(error.response?.data?.message || 'Gagal menyimpan pengaturan SHU')
    } finally {
      setLoading(false)
    }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(value || 0)
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card shadow border-0">
          <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <h5 className="m-0 font-weight-bold">Perhitungan SHU (Sisa Hasil Usaha)</h5>
            <button className="btn btn-sm btn-light" onClick={() => setShowSettings(!showSettings)}>
              <i className="fas fa-cog mr-1"></i> Pengaturan
            </button>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            {showSettings && (
              <div className="card mb-3">
                <div className="card-header">
                  <h6 className="m-0">Pengaturan SHU Tahun {tahun}</h6>
                </div>
                <div className="card-body">
                  <form onSubmit={saveSettings}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Total SHU (Rp)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={settingsForm.DanaCadangan}
                            onChange={(e) => setSettingsForm({ ...settingsForm, DanaCadangan: parseFloat(e.target.value) || 0 })}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Jasa Modal (%)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={settingsForm.JasaModal}
                            onChange={(e) => setSettingsForm({ ...settingsForm, JasaModal: parseFloat(e.target.value) || 0 })}
                            required
                            max="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Jasa Usaha (%)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={settingsForm.JasaAnggota}
                            onChange={(e) => setSettingsForm({ ...settingsForm, JasaAnggota: parseFloat(e.target.value) || 0 })}
                            required
                            max="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Dana Pengurus (%)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={settingsForm.DanaPengurus}
                            onChange={(e) => setSettingsForm({ ...settingsForm, DanaPengurus: parseFloat(e.target.value) || 0 })}
                            required
                            max="100"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Dana Sosial (%)</label>
                          <input
                            type="number"
                            className="form-control"
                            value={settingsForm.DanaSosial}
                            onChange={(e) => setSettingsForm({ ...settingsForm, DanaSosial: parseFloat(e.target.value) || 0 })}
                            required
                            max="100"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? 'Menyimpan...' : 'Simpan Pengaturan'}
                      </button>
                      <button type="button" className="btn btn-secondary ml-2" onClick={() => setShowSettings(false)}>
                        Batal
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Tahun</label>
                <input
                  type="number"
                  className="form-control"
                  value={tahun}
                  onChange={(e) => setTahun(parseInt(e.target.value))}
                  min="2000"
                  max="2100"
                />
              </div>
              <div className="col-md-8 d-flex align-items-end">
                <button className="btn btn-success" onClick={calculateSHU} disabled={loading}>
                  {loading ? 'Menghitung...' : 'Hitung SHU'}
                </button>
              </div>
            </div>

            {shuData && (
              <>
                <div className="alert alert-info">
                  <h6 className="alert-heading">
                    Ringkasan SHU: {shuData.period 
                      ? `${new Date(shuData.period.startDate).toLocaleDateString('id-ID', { month: 'long' })} ${new Date(shuData.period.startDate).getFullYear()} - ${new Date(shuData.period.endDate).toLocaleDateString('id-ID', { month: 'long' })} ${new Date(shuData.period.endDate).getFullYear()}`
                      : `Tahun ${tahun}`}
                  </h6>
                  <table className="table table-sm mb-0">
                    <tbody>
                      <tr>
                        <td>Total SHU</td>
                        <td className="text-right">{formatCurrency(shuData.TotalSHU)}</td>
                      </tr>
                      <tr>
                        <td>Alokasi Jasa Modal ({shuData.AlokasiJasaModal}%)</td>
                        <td className="text-right">{formatCurrency(shuData.SHUJasaModal)}</td>
                      </tr>
                      <tr>
                        <td>Alokasi Jasa Usaha ({shuData.AlokasiJasaUsaha}%)</td>
                        <td className="text-right">{formatCurrency(shuData.SHUJasaUsaha)}</td>
                      </tr>
                      <tr>
                        <td>Alokasi Dana Pengurus ({shuData.AlokasiDanaPengurus}%)</td>
                        <td className="text-right">{formatCurrency(shuData.SHUDanaPengurus)}</td>
                      </tr>
                      <tr>
                        <td>Alokasi Dana Sosial ({shuData.AlokasiDanaSosial}%)</td>
                        <td className="text-right">{formatCurrency(shuData.SHUDanaSosial)}</td>
                      </tr>
                      <tr>
                        <td><strong>Alokasi Dana Cadangan ({shuData.AlokasiDanaCadangan}%)</strong></td>
                        <td className="text-right"><strong>{formatCurrency(shuData.SHUDanaCadangan)}</strong></td>
                      </tr>
                      <tr>
                        <td>Total Simpanan Koperasi</td>
                        <td className="text-right">{formatCurrency(shuData.TotalSimpananKoperasi)}</td>
                      </tr>
                      <tr>
                        <td>Total Transaksi Koperasi</td>
                        <td className="text-right">{formatCurrency(shuData.TotalTransaksiKoperasi)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="table-responsive">
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>NBA</th>
                        <th>Nama</th>
                        <th>Simpanan</th>
                        <th>Transaksi</th>
                        <th>Jasa Modal (JM)</th>
                        <th>Jasa Usaha (JU)</th>
                        <th>Total SHU</th>
                      </tr>
                    </thead>
                    <tbody>
                      {shuData.PerAnggota.map((item, index) => (
                        <tr key={item.NBA}>
                          <td>{index + 1}</td>
                          <td>{item.NBA}</td>
                          <td>{item.Nama}</td>
                          <td>{formatCurrency(item.SimpananAnggota)}</td>
                          <td>{formatCurrency(item.TransaksiAnggota)}</td>
                          <td>{formatCurrency(item.JasaModal)}</td>
                          <td>{formatCurrency(item.JasaUsaha)}</td>
                          <td className="table-primary font-weight-bold">{formatCurrency(item.TotalSHU)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="table-secondary">
                        <td colSpan="7" className="text-right font-weight-bold">Total</td>
                        <td className="font-weight-bold">{formatCurrency(shuData.PerAnggota.reduce((sum, item) => sum + item.TotalSHU, 0))}</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SHU
